import { Box, Button, Typography } from "@mui/material";
import { ChangeCardStatus } from "@arelia-components/ui-atoms/ChangeCardStatus";
import { RevenueOverview } from "@arelia-types/earnings";
import calcDifference from "@arelia-utils/helpers/calcDifference";
import { formatCurrency } from "@arelia-utils/helpers/formatCurrency";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ArelTooltip } from "@arelia-components/ui-atoms/Tooltip";
import { ColumnDef, DataGrid } from "@arelia-components/ui-atoms/data-grid";
import { MouseEvent } from "react";

export interface RevenuePresenterProps {
  data: RevenueOverview;
  records: any[];
  columnConfig: ColumnDef[];
  receiveAllData: (event: MouseEvent<HTMLButtonElement>) => void;
  selectedPeriod?: string;
}

const columnDefaults: Partial<ColumnDef> = {
  renderer: p => p.value || '-'
}

export function RevenuePresenter({ data, records, columnConfig, selectedPeriod, receiveAllData }: RevenuePresenterProps) {
  return (
    <>
      <Box sx={styles.header.wrapper}>
        <Typography variant="h2" sx={styles.header.total}>
          {formatCurrency(data.total)} Total
          {
            !data.topLevelTotal
            ? <></>
            : <ArelTooltip title="Grand total of all revenues" style={styles.header.totalTip}>
                <InfoOutlinedIcon />
              </ArelTooltip>
          }
        </Typography>
        {
          !data.topLevelTotal
          ? <></>
          : <Typography variant="subtitle2" sx={styles.header.performance}>({formatCurrency(data.topLevelTotal)} Performance)</Typography>
        }
      </Box>
      <ChangeCardStatus change={calcDifference(data.totalThisPeriod, data.totalPrevPeriod)} timespan={selectedPeriod} />
      <Box sx={styles.data.wrapper}>
        <DataGrid
          sx={styles.data.table}
          columns={columnConfig}
          columnDefaults={columnDefaults}
          rows={records} />

        {(data?.totalRecordCount ?? 0) > 5 && records.length <= 5 && (
          <Box sx={styles.data.seeAll}>
            <Button variant="transparent" onClick={receiveAllData}>See All Events</Button>
          </Box>
        )}
      </Box>

    </>
  );
}

const styles = {
  header: {
    wrapper: {
      display: "flex",
      alignItems: "center",
      marginBottom: "8px"
    },
    total: {
      margin: 0
    },
    totalTip: {
      cursor: "pointer",
      marginLeft: "6px"
    },
    performance: {
      fontSize: "16px",
      marginLeft: "12px"
    }
  },
  data: {
    wrapper: {
      height: "335px"
    },
    table: {
      marginTop: 2,
      height: "calc(100% - 20px)"
    },
    seeAll: {
      position: "absolute",
      left: "calc(50% - 70px)",
      bottom: "20px"
    }
  }
}